<div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-content">
        <div class="row">
            <div class="col-md-12">
                <div class="m-portlet m-portlet--tab">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <span class="m-portlet__head-icon m--hide">
                                    <i class="la la-gear"></i>
                                </span>
                                <h4 class="m-portlet__head-text">{{ formTitle }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                        <button class="open-accordion" (click)="toggleIntroduction()">
                            <span style="color: black;">Introduction</span>
                            <span style="color: black;" *ngIf="!isIntroductionExpanded" class="indicator">&#9658;</span>
                            <span style="color: black;" *ngIf="isIntroductionExpanded" class="indicator">&#9660;</span>
                        </button>
                        <div #introductionPanel class="open-panel"
                            [ngStyle]="{'max-height': isIntroductionExpanded ? getPanelHeight() : '0px'}">
                            <div class="intContent">
                                <p>
                                    Please refer to the following pointers for form filling:
                                </p>
                                <ul class="mb-0">
                                    <li>
                                        All institutes under PM Vishwakarma are to nominate their trainers for upcoming
                                        Training of Trainer (ToT).
                                    </li>
                                    <li>
                                        Please provide details of Trainer/Assessor from your institute under Section 2.
                                    </li>
                                    <li class="text-danger">
                                        Please enter TR/AR ID correctly and verify before submission. No manual changes
                                        shall be done later.
                                    </li>
                                    <li>
                                        Please provide details of your Institute and SPOC under Section 1.
                                    </li>
                                </ul>
                                <br>
                                <p>
                                    Please upload any 2 relevant documents to comply with ToT as per details below:
                                </p>
                                <ul>
                                    <li class="text-danger">Experience document (trade relevant)</li>
                                    <li class="text-danger">Education Certificate (trade relevant)</li>
                                    <li class="text-danger">Complete resume/Trade specific photo</li>
                                    <li class="text-danger">Undertaking on Institute's letterhead signed by competent
                                        authority.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-group m-form__group m--margin-top-10 form_header">
                            Nominate as:
                        </div>
                        <div class="m-form__group form-group row">
                            <div class="col-lg-3 col-form-label">
                                <div class="m-radio-inline d-flex gap-3" *ngIf="typeOfSkilling">
                                    <label class="m-radio m-radio--success">
                                        <input type="radio" name="nominationOption" value="trainer"
                                            [(ngModel)]="nominationOption" (change)="onOptionChange('trainer')"
                                            class="form-control">Trainer
                                        <span></span>
                                    </label>

                                    <label class="m-radio m-radio--success">
                                        <input type="radio" name="nominationOption" value="assessor"
                                            [(ngModel)]="nominationOption" (change)="onOptionChange('assessor')"
                                            class="form-control">Assessor
                                        <span></span>
                                    </label>

                                    <label class="m-radio m-radio--success" *ngIf="typeOfSkilling ==='basic'">
                                        <input type="radio" name="nominationOption" value="both"
                                            [(ngModel)]="nominationOption" (change)="onOptionChange('both')"
                                            class="form-control">Both
                                        <span></span>
                                    </label>
                                </div>
                            </div>

                        </div>

                        <div class="form-group m-form__group m--margin-top-10 form_header">
                            Details Of Institute and SPOC:
                        </div>
                        <div class="m-form__section m-form__section--first" [formGroup]="nominationForm"
                            *ngIf="typeOfSkilling==='basic' || typeOfSkilling==='advance'">
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Name Of Institute:
                                        <span id="FirstNameabsoluteAsterick">*</span>
                                    </label>
                                    <div class="col-lg-8">
                                        <input class="form-control m-input notranslate" type="text"
                                            placeholder="Enter Name Of Institute" formControlName="nameOfInstitute" />
                                        <app-form-control-messages [control]="
                                   nominationForm.get('nameOfInstitute')" [name]="'Name Of Institute'">
                                        </app-form-control-messages>
                                    </div>
                                </div>
                            </ng-container>



                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Type Of Institute:
                                        <span id="FirstNameabsoluteAsterick">*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="typeOfInstitute">
                                            <option value="" selected disabled>Select Type Of Institute</option>
                                            <option *ngFor="let opt of typesOfInstitutes" [value]="opt">{{opt}}</option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('typeOfInstitute')"
                                            [name]="'Type Of Institute'"></app-form-control-messages>

                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        TP SPOC Email ID:<span id="mandatoryColor">*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control m-input notranslate" maxlength="50"
                                            placeholder="Enter Email Address" formControlName="tpEmail">
                                        <small class="form-text text-muted">
                                            (Kindly provide correct & functional Email Id to do appropriate
                                            communication in future)
                                        </small>
                                        <div *ngIf="nominationForm.get('tpEmail')?.errors?.invalidEmailAddress 
              && nominationForm.get('tpEmail')?.value">
                                            <small class="text-danger">Please enter a valid email address</small>
                                        </div>
                                        <app-form-control-messages [control]="nominationForm.get('tpEmail')"
                                            [name]="'TP SPOC Email'"></app-form-control-messages>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        TP ID:<span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <input type="text" class="form-control m-input notranslate"
                                            placeholder="Enter TP ID" formControlName="tpId" maxlength="9">
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        TC ID:<span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control m-input notranslate"
                                            placeholder="Enter TC ID" formControlName="tcId" maxlength="9">
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Name Of TC SPOC:<span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <input type="text" class="form-control m-input notranslate"
                                            placeholder="Enter Name Of TC SPOC" formControlName="tcSpocName">
                                        <app-form-control-messages [control]="nominationForm.get('tcSpocName')"
                                            [name]="'Spoke Name'"></app-form-control-messages>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        TC SPOC Email ID:<span id="mandatoryColor">*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control m-input notranslate" maxlength="50"
                                            placeholder="Enter TC SPOC Email ID" formControlName="tcSpocEmail">
                                        <small class="form-text text-muted">
                                            (Kindly provide correct & functional Email Id to do appropriate
                                            communication in future)
                                        </small>
                                        <div *ngIf="nominationForm.get('tcSpocEmail')?.errors?.invalidEmailAddress 
              && nominationForm.get('tcSpocEmail')?.value">
                                            <small class="text-danger">Please enter a valid email address</small>
                                        </div>
                                        <app-form-control-messages [control]="nominationForm.get('tcSpocEmail')"
                                            [name]="'TC SPOC Email'"></app-form-control-messages>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Contact Number:<span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <input type="number" class="form-control m-input notranslate" maxlength="10"
                                            placeholder="Enter Contact Number" formControlName="contactNumber">
                                        <app-form-control-messages [control]="nominationForm.get('contactNumber')"
                                            [name]="'Contact Number'"></app-form-control-messages>
                                        <!-- <input class="form-control m-input notranslate" type="number" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
					event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
					57" formControlName="alternateMobileNumber" minlength="10" maxlength="10"
					oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					placeholder="Enter Alternate Mobile"> -->
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        Designation:<span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control m-input notranslate"
                                            placeholder="Enter Designation" formControlName="designation">
                                        <app-form-control-messages [control]="nominationForm.get('designation')"
                                            [name]="'Designation'"></app-form-control-messages>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        State:<span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="state">
                                            <option value="" selected disabled>Select State</option>
                                            <option [ngValue]="stateData" *ngFor="let stateData of stateOptions">
                                                {{stateData.name}}</option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('state')"
                                            [name]="'state'"></app-form-control-messages>

                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        District:<span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="district">
                                            <option value="" selected disabled>Select District</option>
                                            <option *ngFor="let district of districts" [ngValue]="district">
                                                {{district.name}}</option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('district')"
                                            [name]="'district'"></app-form-control-messages>

                                    </div>
                                </div>
                            </ng-container>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    LGD Code:
                                </label>
                                <div class="col-lg-2">
                                    <input type="number" class="form-control m-input notranslate"
                                        placeholder="Enter LGD Code" formControlName="lgdCode" readonly>
                                    <app-form-control-messages [control]="nominationForm.get('lgdCode')"
                                        [name]="'Lgd Code'"></app-form-control-messages>
                                </div>
                            </div>
                            <ng-container>
                                <div class="m-form__heading">
                                    <h3 class="form-group m-form__group m--margin-top-10 form_header">
                                        Fill Details Of Trainer/Assessor:
                                    </h3>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Name Of Participants:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="m-radio-inline">
                                            <input type="text" class="form-control m-input notranslate"
                                                placeholder="Enter Name Of Participants"
                                                formControlName="participantName">
                                            <small class="form-text text-muted">
                                                (Please enter your name as per Aadhaar)
                                            </small>
                                            <app-form-control-messages [control]="nominationForm.get('participantName')"
                                                [name]="'Participant Name'"></app-form-control-messages>
                                        </div>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        Gender:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="gender">
                                            <option value="" selected disabled>Select Gender</option>
                                            <option *ngFor="let genderOption of genderOptions" [ngValue]="genderOption">
                                                {{ genderOption }}
                                            </option>
                                        </select>
                                        <small class="form-text text-muted">
                                            (Please select your gender as per Aadhaar)
                                        </small>
                                        <app-form-control-messages [control]="nominationForm.get('gender')"
                                            [name]="'Gender'"></app-form-control-messages>

                                    </div>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Email ID:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="m-radio-inline">
                                            <input type="text" class="form-control m-input notranslate" maxlength="50"
                                                placeholder="Enter Email ID" formControlName="email">
                                            <small class="form-text text-muted">
                                                (Kindly provide correct & functional Email Id to do appropriate
                                                communication in future)
                                            </small>
                                            <div *ngIf="nominationForm.get('email')?.errors?.invalidEmailAddress 
              && nominationForm.get('email')?.value">
                                                <small class="text-danger">Please enter a valid email address</small>
                                            </div>
                                            <app-form-control-messages [control]="nominationForm.get('email')"
                                                [name]="'Email'"></app-form-control-messages>
                                        </div>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        Mobile Number:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="number" class="form-control m-input notranslate" maxlength="10"
                                            placeholder="Enter Mobile Number" formControlName="mobileNumber">
                                        <app-form-control-messages [control]="nominationForm.get('mobileNumber')"
                                            [name]="'Mobile Number'"></app-form-control-messages>

                                    </div>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Date of Birth:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <app-date-picker-bootstrap [dateInput]="dateInput.startDate"
                                            (dateChanged)="onDateChange($event, i, 'startDate' )"
                                            [isDisabledNomination]="nominationForm.get('dob')?.disabled"></app-date-picker-bootstrap>
                                        <small class="form-text text-muted">
                                            (Please enter your date of birth as per Aadhaar)
                                        </small>
                                        <app-form-control-messages [control]="nominationForm.get('dob')"
                                            [name]="'Date of Birth'">
                                        </app-form-control-messages>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        Aadhaar Number:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="number" class="form-control m-input notranslate"
                                            placeholder="Enter Aadhaar Number" formControlName="aadhaarNumber">
                                        <app-form-control-messages [control]="nominationForm.get('aadhaarNumber')"
                                            [name]="'Aadhaar Number'"></app-form-control-messages>
                                        <br>
                                        <small>
                                            <button *ngIf="!_isAadhaarValidated"
                                                [disabled]="nominationForm.get('aadharNumber')?.invalid"
                                                (click)="validate()" type="button"
                                                class="btn btn-secondary">Verify</button></small>
                                        <span *ngIf="_isAadhaarValidated" style="color: green;">Verified</span>
                                    </div>
                                    <ng-container>
                                    </ng-container>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        State:<span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="nomineeState">
                                            <option value="" selected disabled>Select State</option>
                                            <option [ngValue]="stateData" *ngFor="let stateData of stateOptions">
                                                {{stateData.name}}</option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('nomineeState')"
                                            [name]="'State'"></app-form-control-messages>

                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        District:<span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="nomineeDistrict">
                                            <option value="" selected disabled>Select District</option>
                                            <option *ngFor="let district of nomineeDistricts" [ngValue]="district">
                                                {{district.name}}</option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('nomineeDistrict')"
                                            [name]="'District'"></app-form-control-messages>

                                    </div>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        LGD Code:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <input type="number" class="form-control m-input notranslate"
                                            placeholder="Enter LGD Code" formControlName="nomineeLgdCode" readonly>
                                        <!-- <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="lgdCode">
                                            <option value="" selected disabled>Select LGD Code</option>
                                            
                                        </select> -->
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        User Category:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="userCategory">
                                            <option value="" selected disabled>Select User Category</option>
                                            <option *ngFor="let Category of typesOfuserCategories" [value]="Category">
                                                {{Category}}</option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('userCategory')"
                                            [name]="'User Category'"></app-form-control-messages>

                                    </div>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row"
                                    *ngIf="nominationOption ==='trainer' || nominationOption ==='both'">
                                    <label class="col-lg-3 col-form-label">
                                        TR ID:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="m-radio-inline">
                                            <input type="text" class="form-control m-input notranslate"
                                                placeholder="Enter TR ID" formControlName="trId">
                                            <app-form-control-messages [control]="nominationForm.get('trId')"
                                                [name]="'TR Id'"></app-form-control-messages>
                                            <div *ngIf="nominationForm.get('trId')?.touched && nominationForm.get('trId')?.hasError('startsWith')"
                                                class="text-danger">
                                                TR ID must start with {{
                                                nominationForm.get('trId')?.getError('startsWith').requiredPrefixes.join('
                                                or ')
                                                }}
                                            </div>
                                            <!-- <div *ngIf="nominationForm.get('trId')?.touched && nominationForm.get('trId')?.hasError('startsWith')"
                                                class="text-danger">
                                                TR ID must start with {{
                                                nominationForm.get('trId')?.getError('startsWith').requiredPrefix }}
                                            </div> -->
                                        </div>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        TR ID Prefix:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control m-input notranslate"
                                            placeholder="Enter TR ID Prefix" formControlName="trIdPrefix">
                                        <app-form-control-messages [control]="nominationForm.get('trIdPrefix')"
                                            [name]="'TR Id Prefix'"></app-form-control-messages>
                                        <!-- <div *ngIf="nominationForm.get('trIdPrefix')?.touched && nominationForm.get('trIdPrefix')?.hasError('startsWith')"
                                                class="text-danger">
                                                TR ID Prefix must start with {{
                                                nominationForm.get('trIdPrefix')?.getError('startsWith').requiredPrefixes.join('
                                                or ')
                                                }}
                                            </div> -->

                                    </div>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row"
                                    *ngIf="nominationOption ==='assessor' || nominationOption ==='both'">
                                    <label class="col-lg-3 col-form-label">
                                        AR ID:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="m-radio-inline">
                                            <input type="text" class="form-control m-input notranslate"
                                                placeholder="Enter AR ID" formControlName="arId">
                                            <app-form-control-messages [control]="nominationForm.get('arId')"
                                                [name]="'AR Id'"></app-form-control-messages>
                                            <div *ngIf="nominationForm.get('arId')?.touched && nominationForm.get('arId')?.hasError('startsWith')"
                                                class="text-danger">
                                                AR ID must start with {{
                                                nominationForm.get('arId')?.getError('startsWith').requiredPrefixes.join('
                                                or ')
                                                }}
                                            </div>
                                            <!-- <div *ngIf="nominationForm.get('arId')?.touched && nominationForm.get('arId')?.hasError('startsWith')"
                                                class="text-danger">
                                                AR ID must start with {{
                                                nominationForm.get('arId')?.getError('startsWith').requiredPrefix }}
                                            </div> -->
                                        </div>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        AR ID Prefix:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control m-input notranslate"
                                            placeholder="Enter AR ID Prefix" formControlName="arIdPrefix">
                                        <app-form-control-messages [control]="nominationForm.get('arIdPrefix')"
                                            [name]="'AR Id Prefix'"></app-form-control-messages>
                                        <!-- <div *ngIf="nominationForm.get('arIdPrefix')?.touched && nominationForm.get('arIdPrefix')?.hasError('startsWith')"
                                                class="text-danger">
                                                AR ID must start with {{
                                                nominationForm.get('arIdPrefix')?.getError('startsWith').requiredPrefixes.join('
                                                or ')
                                                }}
                                            </div> -->
                                    </div>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Sector:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="sector"
                                            (change)="onSectorChange(nominationForm.get('sector').value)">
                                            <option value="" selected disabled>Select Sector</option>
                                            <option *ngFor="let sectorObject of sectors" [ngValue]="sectorObject">
                                                {{sectorObject.sector}}
                                            </option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('sector')"
                                            [name]="'Sector'"></app-form-control-messages>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        Trade Name:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="tradeName">
                                            <option value="" selected disabled>Select Trade Name </option>
                                            <option *ngFor="let tName of tradeNames" [value]="tName">{{ tName }}
                                            </option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('tradeName')"
                                            [name]="'Trade Name'"></app-form-control-messages>
                                        <div *ngIf="tradeMessage" class="text-danger mt-1">
                                            {{ tradeMessage }}
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        NOS Code:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="nosCode">
                                            <option value="" selected disabled>Select NOS Code </option>
                                            <option *ngFor="let nos of nosCodes" [value]="nos">{{ nos }}</option>
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('nosCode')"
                                            [name]="'nosCode'"></app-form-control-messages>

                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        Preferred Language:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-3">
                                        <div class="form-select-side">
                                            <svg width="10px" height="12px" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
                                                enable-background="new 0 0 129 129">
                                                <g>
                                                    <path
                                                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <select class="form-control m-input notranslate" id="exampleSelect1"
                                            formControlName="preferredLanguage">
                                            <option value="" selected disabled>Select Preferred Language</option>
                                            <option *ngFor="let lang of preferredLanguages" [value]="lang">
                                                {{ lang }}
                                            </option>
                                            <!-- <option *ngFor="let assessmentLanguage of assessmentLanguagesList"
                                                [value]="assessmentLanguage">{{assessmentLanguage}}</option> -->
                                        </select>
                                        <app-form-control-messages [control]="nominationForm.get('preferredLanguage')"
                                            [name]="'preferredLanguage'"></app-form-control-messages>

                                    </div>

                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        WhatsApp Number:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <div class="m-radio-inline">
                                            <input type="number" class="form-control m-input notranslate" maxlength="10"
                                                placeholder="Enter WhatsApp Number" formControlName="whatsappNumber">
                                            <app-form-control-messages [control]="nominationForm.get('whatsappNumber')"
                                                [name]="'whatsapp Number'"></app-form-control-messages>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="m-form__heading">
                                    <h3 class="form-group m-form__group m--margin-top-10 form_header">
                                        Upload Trainer/Assessor Eligibility Documents::
                                    </h3>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Trade Specific Photo/Video:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <app-upload-file [formValue]="nominationForm.get('photoVideo')"
                                            [allowedFormats]="allowedFormats" [(localFile)]="localFileName.photoVideo"
                                            fileType="photoVideo"
                                            info="only jpg, png, jpeg,mp4, JPG, PNG, JPEG,MP4"></app-upload-file>
                                        <input type="hidden" formControlName="photoVideo" #fileInput>
                                        <app-form-control-messages [control]="nominationForm.controls.photoVideo"
                                            [name]="'Upload Related Document'"></app-form-control-messages>
                                    </div>
                                    <label class="col-lg-3 col-form-label">
                                        Trade relavant certificate/documents:
                                        <span>*</span>
                                    </label>

                                    <div class="col-lg-3">
                                        <app-upload-file [formValue]="nominationForm.get('tradeCertificateDocs')"
                                            [allowedFormats]="onlyFilesAllowedFormats"
                                            [(localFile)]="localFileName.tradeCertificateDocs"
                                            fileType="tradeCertificateDocs"
                                            info="only jpg, png, jpeg, JPG, PNG, JPEG"></app-upload-file>
                                        <input type="hidden" formControlName="tradeCertificateDocs" #fileInput>
                                        <app-form-control-messages
                                            [control]="nominationForm.controls.tradeCertificateDocs"
                                            [name]="'Upload Related Document'"></app-form-control-messages>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">
                                        Undertaking by institute:
                                        <span>*</span>
                                    </label>
                                    <div class="col-lg-2">
                                        <app-upload-file [formValue]="nominationForm.get('undertaking')"
                                            [allowedFormats]="onlyFilesAllowedFormats"
                                            [(localFile)]="localFileName.undertaking" fileType="undertaking"
                                            info="only jpg, png, jpeg, JPG, PNG, JPEG"></app-upload-file>
                                        <input type="hidden" formControlName="undertaking" #fileInput>
                                        <app-form-control-messages [control]="nominationForm.controls.undertaking"
                                            [name]="'Upload Related Document'"></app-form-control-messages>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="m-portlet__foot m-portlet__foot--fit">
                            <div class="m-form__actions">
                                <div class="row">
                                    <div class="col-3">
                                    </div>
                                    <div class="col-8" style="padding-top: 35px;">
                                        <button class="btn btn-primary blue-btn" [disabled]="!validForm"
                                            (click)="submitNominationForm()">Submit</button>&nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>